const plugin = (editor) => {

  // // Standard Template Anweisung
  // editor.DomComponents.addType('template-cmd',{
  //   isComponent: el => el.attributes && el.attributes.name && el.attributes.name.value === 'templatecmd',
  //   model: {
  //     defaults: {
  //       editable: true,
  //       selectable: true,
  //       dragable: true,
  //       attributes: {
  //         "name":"templatecmd",
  //       },
  //       type: 'text',
  //       tagName: 'span',
  //       content: ''
  //     },
  //   },
  //   view: {
  //   		events: {
  //   			dblclick: 'onActive',
  //   			focusout: 'onDisable',
  //   		},
  //   		onActive() {
  //   			this.el.contentEditable = true;
  //   		},
  //   		onDisable() {
  //   			const { el, model } = this;
  //   			el.contentEditable = false;
  //   			model.set('content', el.innerHTML)
  //   		},
  //   	}
  // });

  editor.Blocks.add('ts-template-cmd',{
    label: 'Template Variable',
    category: 'Vorlage',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z"/></svg>',
    content: '<span name="templatecmd">$MyVariable</span>'
  });

  editor.Blocks.add('ts-template-list',{
    label: 'Template Liste',
    category: 'Vorlage',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"/></svg>',
    content: '<ul><li><span outer="li" name="templatecmd">#foreach( $item in $list )</span></li><li>$item</li><li><span outer="li" name="templatecmd">#end</span></li></ul>'
  });

  editor.Blocks.add('ts-template-table',{
    label: 'Template Tabelle',
    category: 'Vorlage',
    media: '<svg xmlns="http://www.w3.org/2000/svg" height="3em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"/></svg>',
    content: '<table><thead><tr><th><span>Spalte1</span></th><th><span>Spalte2</span></th><th>Spalte3</th><th><span>Spalte4</span></th></tr></thead><tbody><tr><td colspan="20"><span name="templatecmd" outer="tr">#forech( $item in $list )</span></td></tr><tr><td><span>$item.attr1</span></td><td><span>$item.attr2</span></td><td><span>$item.attr3</span></td><td><span>$item.attr4</span></td></tr><tr><td colspan="20"><span outer="tr" name="templatecmd">#end</span></td></tr></tbody></table>'
  });


}

export default plugin;
